/**
 * Formats a number with two decimal places and concatenates with currency.
 *
 * @param {number} amount - The price amount.
 * @param {string} currency - The currency code or label.
 * @returns {string} - Formatted as "amount currency" (e.g., "200.00 MAD").
 *
 * @example
 * formatMoney(200);     // "200.00 MAD"
 * formatMoney(19.5);    // "19.50 MAD"
 */
export function formatMoney(amount, currency = 'MAD') {
    if (!amount) return `0.00 ${currency}`;
    const numericAmount = typeof amount === 'string' ? parseFloat(amount) : amount;
    if (isNaN(numericAmount)) return `0.00 ${currency}`;
    return `${numericAmount.toFixed(2)} ${currency}`;
  }